import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAnglesDown } from '@fortawesome/free-solid-svg-icons';

const Hero = () => {
  const vantaRef = useRef(null);
  const [vantaEffect, setVantaEffect] = useState(null);

  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(window.VANTA.NET({
        el: vantaRef.current,
        mouseControls: false,
        touchControls: false,
        gyroControls: false,
        scale: 1.00,
        scaleMobile: 1.00,
        color: 0x267373,
        backgroundColor: 0xfbfbfb,
        points: 10.0,
        maxDistance: 20.0,
        spacing: 15.0
      }));
    }

    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [vantaEffect]);

  return (
    <section id="Hero" ref={vantaRef}>
      <div className="hero-content">
        <div className="hero-content-detail">
          <h1>Hi, I'm <span className='hero-name'>Ignatius Michael</span></h1>
          <h2>Front-End Developer | UI Enthusiast</h2>
          <p>I build modern, responsive, and user-focused web experiences.</p>
        </div>
        <div className="hero-buttons">
          <a href="/portfolio" className="hero-btn">View Portfolio</a>
          <a href="/contact" className="hero-btn">Let's Talk</a>
        </div>
      </div>
      <a href="#AboutPage" className="hero-bouncing-wrap" onClick={(e) => {
        e.preventDefault();
        const target = document.querySelector("#AboutPage");
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        }
      }}>
        <div className="hero-bouncing">
          <p>About Me</p>
          <FontAwesomeIcon icon={faAnglesDown} />
        </div>
      </a>
    </section>
  );
};

export default Hero;
